<div class="popup-container" *ngIf="showError">
    <div class="popup-model">
        <div class="popup-header">
            <div class="popup-header-text">{{headerTitle}}</div>
            <div class="popup-close" (click)="close()" title="Close"></div>
        </div>
        <div class="popup-body">
            <div class="popup-body-block1">
                <div class="message-block"[ngStyle]="{
                    display:customcss(messageText),'height':heightValue
                }">
                    {{messageText}}
                </div>
            </div>
            <div class="popup-body-block2">
                 <div class="popup-body-navigation-txt"> Consider the following navigation for {{navigationText}}</div>
                 <div class="popup-body-navigation-Lists">
                     <div class="Navigation-List" *ngFor="let List of PanelList" [ngClass]="{ 'd-none': !List.hasAccess }">{{List.displayLabel}}</div>
                 </div>
            </div>
        </div>
        <div class="popup-footer">
            <div class="popup-btn" (click)="onOkBtnClick()">
                <!-- <div class="btn-icon check-circle-icon"></div> -->
                <div class="btn-text">{{buttonText}}</div>
            </div>
        </div>
    </div>
</div>